import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AccesPortailComponent, IsNumericPipe } from './acces-portail.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    
  ],
  declarations: [
    AccesPortailComponent,
    IsNumericPipe
  ],
  exports: [
    AccesPortailComponent
  ],
  providers: [IsNumericPipe]
})

export class AccesPortailModule { }
